export function groupSimultaneousEvents(events: any[]) {
  const grouped: Record<string, any[]> = {};
  events.forEach((e) => {
    const key = `${new Date(e.startTime).getTime()}`;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(e);
  });

  const result: any[] = [];
  Object.values(grouped).forEach((group) => {
    if (group.length > 3) {
      const visible = group.slice(0, 2);
      const hidden = group.slice(2);
      const moreEvent = {
        ...hidden[0],
        isMoreButton: true,
        hiddenEvents: hidden,
        batchTimeTableId: `more-${hidden[0].batchTimeTableId || Math.random()}`,
      };
      result.push(...visible, moreEvent);
    } else {
      result.push(...group);
    }
  });

  return result;
}

export function layoutEvents(events: any[]) {
  const sortedEvents = [...events]
    .map((e) => ({ ...e }))
    .sort((a, b) => {
      const startA = new Date(a.startTime).getTime();
      const startB = new Date(b.startTime).getTime();
      if (startA !== startB) return startA - startB;
      const endA = new Date(a.endTime).getTime();
      const endB = new Date(b.endTime).getTime();
      return endB - endA;
    });

  const clusters: any[][] = [];
  let currentCluster: any[] = [];
  let clusterEnd = 0;

  sortedEvents.forEach((event) => {
    const start = new Date(event.startTime).getTime();
    const end = new Date(event.endTime).getTime();

    if (currentCluster.length > 0 && start >= clusterEnd) {
      clusters.push(currentCluster);
      currentCluster = [];
      clusterEnd = 0;
    }

    currentCluster.push(event);
    clusterEnd = Math.max(clusterEnd, end);
  });

  if (currentCluster.length > 0) {
    clusters.push(currentCluster);
  }

  const laidOutEvents: any[] = [];

  clusters.forEach((cluster) => {
    const columns: any[][] = [];

    cluster.forEach((event) => {
      let placed = false;
      const start = new Date(event.startTime).getTime();

      for (let i = 0; i < columns.length; i++) {
        const col = columns[i];
        const lastEvent = col[col.length - 1];
        if (new Date(lastEvent.endTime).getTime() <= start) {
          col.push(event);
          placed = true;
          event._col = i;
          break;
        }
      }

      if (!placed) {
        event._col = columns.length;
        columns.push([event]);
      }
    });

    const numCols = columns.length;
    cluster.forEach((event) => {
      const col = event._col;
      const left = (col / numCols) * 100;
      const width = 100 / numCols;

      laidOutEvents.push({
        ...event,
        _layout: {
          left: `calc(${left}% + 2px)`,
          width: `calc(${width}% - 4px)`,
        },
        width: width,
      });
    });
  });

  return laidOutEvents;
}

export function layoutMobileEvents(events: any[]) {
  const grouped: Record<string, any[]> = {};
  events.forEach((e) => {
    const key = `${new Date(e.startTime).getTime()}`;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(e);
  });

  const laidOutEvents: any[] = [];
  Object.values(grouped).forEach((group) => {
    if (group.length > 1) {
      let maxEnd = new Date(group[0].endTime).getTime();
      group.forEach((e) => {
        const end = new Date(e.endTime).getTime();
        if (end > maxEnd) maxEnd = end;
      });

      const first = group[0];
      laidOutEvents.push({
        ...first,
        endTime: new Date(maxEnd).toISOString(),
        isMobileCollapsed: true,
        collapsedEvents: group,
        _layout: {
          left: "4px",
          width: "calc(100% - 8px)",
        },
      });
    } else {
      laidOutEvents.push({
        ...group[0],
        _layout: {
          left: "4px",
          width: "calc(100% - 8px)",
        },
      });
    }
  });

  return laidOutEvents;
}
export const isShowJoinLectureButton: any = (event: any) => {
  if (
    (event.syllabusStatus == "Upcoming" ||
      new Date(new Date()) < new Date(event?.endTime)) &&
    event.eventLink &&
    event.eventLink != "null"
  ) {
    return true;
  }
  return false;
};
